function findRootLayout(routes, routerRoot) {
  var exactKey = `/${routerRoot}/_layout.tsx`;
  if (routes[exactKey]) return routes[exactKey]();
  for (var _i = 0, _iter = [
    "+ssg",
    "+ssr",
    "+spa"
  ]; _i < _iter.length; _i++) {
    var suffix = _iter[_i];
    var key = `/${routerRoot}/_layout${suffix}.tsx`;
    if (routes[key]) return routes[key]();
  }
  var exactKeyTs = `/${routerRoot}/_layout.ts`;
  if (routes[exactKeyTs]) return routes[exactKeyTs]();
  for (var _i1 = 0, _iter1 = [
    "+ssg",
    "+ssr",
    "+spa"
  ]; _i1 < _iter1.length; _i1++) {
    var suffix1 = _iter1[_i1];
    var key1 = `/${routerRoot}/_layout${suffix1}.ts`;
    if (routes[key1]) return routes[key1]();
  }
  return void 0;
}
export {
  findRootLayout
};
//# sourceMappingURL=findRootLayout.js.map
